import QuestionMark from "@mui/icons-material/QuestionMark";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts, appTypography } from "styles/appThemeFonts";
import {
  appThemeRadius,
  appThemeSize,
  appThemeSpace,
} from "styles/appThemeTokens";
import { menuTitleSx } from "../TopHeader.style";

export const HelpTriggerIcon = styled(QuestionMark)({
  fontSize: 18,
});

export const helpMenuWidthSx = {
  width: appThemeSize.menuWidthLg,
  maxWidth: "calc(100vw - 24px)",
};

export const helpMenuListSx = {
  padding: 0,
};

export const helpHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `13px 15px`,
  borderBottom: `1px solid ${appThemeColors.background.soft}`,
};

export const helpTitleSx = {
  ...menuTitleSx,
  margin: 0,
};

export const helpCloseButtonSx = {
  width: appThemeSize.iconButtonXs,
  height: appThemeSize.iconButtonXs,
  borderRadius: appThemeRadius.md,
  color: appThemeColors.text.muted,
  backgroundColor: appThemeColors.background.main,
  padding: 0,
  "&:hover": {
    backgroundColor: appThemeColors.background.soft,
  },
  "& .MuiSvgIcon-root": {
    width: 15,
    height: 15,
  },
};

export const helpBodySx = {
  padding: `${appThemeSpace.xl} 15px`,
};

export const helpSectionLabelSx = {
  ...appTypography.helpSectionLabel,
  color: appThemeColors.text.faint,
  marginBottom: appThemeSpace.sm,
};

export const helpTextSx = {
  fontFamily: appThemeFonts.family.ui,
  fontSize: appThemeFonts.size.base,
  color: appThemeColors.text.primary,
};

export const helpPhoneSx = {
  fontWeight: appThemeFonts.weight.semibold,
  color: appThemeColors.text.heading,
};
